/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Add_WeightInputs */

const en_ui_thresholds_add_weight = /** @type {(inputs: Ui_Thresholds_Add_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add weight`)
};

const de_ui_thresholds_add_weight = /** @type {(inputs: Ui_Thresholds_Add_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht eintragen`)
};

/**
* | output |
* | --- |
* | "Add weight" |
*
* @param {Ui_Thresholds_Add_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_add_weight = /** @type {((inputs?: Ui_Thresholds_Add_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Add_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_add_weight(inputs)
	return de_ui_thresholds_add_weight(inputs)
});